import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { MapApi } from '../../../api/map-api';
import { UserApi } from '../../../api/user-api';
import { environment } from '../../../environment';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';
var SaveMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SaveMapComponent, _super);
    function SaveMapComponent(_vcr, authService, layerService, mapService, userApi, mapApi, cdr) {
        var _this = _super.call(this, _vcr) || this;
        _this.authService = authService;
        _this.layerService = layerService;
        _this.mapService = mapService;
        _this.userApi = userApi;
        _this.mapApi = mapApi;
        _this.cdr = cdr;
        _this.userId = null;
        _this.applicationId = environment.appId;
        _this.showPublic = true;
        _this.isNewMap = null;
        _this.isSaving = false;
        _this.isSystem = false;
        _this.createNewFolder = false;
        _this.newFolder = null;
        _this.parentFolders = [];
        _this.parentFolderId = 0;
        _this.mapLayers = [];
        _this.unsavedLayers = [];
        _this.disableCreateMap = true;
        _this.isExistingMap = false;
        _this.nonPublicLayers = [];
        _this.isLoading = false;
        _this.onsave = new EventEmitter();
        _this.PUBLIC_LAYER_NAMES = new Set([
            'View Public Data',
            'MapCore Public Layers',
            'Mapcore Public Layers'
        ]);
        _this.saveMap = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, layers, originalLayers, basemapIds, layers_1, layers_1_1, layer, mapcoreLayer, mapcoreLayer, _c, _d, groupedLayer, groupedMapcoreLayer, _e, currentFolder, layerIds, layersFromApi_1;
            var _this = this;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.isSaving = true;
                        layers = this.mapRef.layers.items;
                        layers = layers.filter(function (x) { return x.mapcoreProps && !x.mapcoreProps.hideInLegend && (!x.listMode || x.listMode !== 'hide'); });
                        if (this.hasNonPublicLayers(layers)) {
                            return [2 /*return*/];
                        }
                        this.mapLayers = [];
                        originalLayers = [];
                        if (this.mapRef.basemap) {
                            basemapIds = ['terrain', 'streets-vector', 'satellite', 'hybrid', 'topo-vector', 'gray-vector', 'osm'];
                            if (basemapIds.includes(this.mapRef.basemap.id)) {
                                this.map.basemap = JSON.stringify({ type: 'ID', id: "" + this.mapRef.basemap.id });
                            }
                            else if (this.mapRef.basemap.id.includes('Bing')) {
                                this.map.basemap = JSON.stringify({ type: 'BING', id: "" + this.mapRef.basemap.id });
                            }
                            else {
                                this.map.basemap = JSON.stringify({ type: 'CONFIG', id: "" + this.mapRef.basemap.id });
                            }
                        }
                        try {
                            for (layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                                layer = layers_1_1.value;
                                if (layer.type !== 'group') {
                                    originalLayers.push(layer);
                                    mapcoreLayer = this.layerService.getLayerForSaveMap(layer, this.isNewMap);
                                    this.mapLayers.push(mapcoreLayer);
                                }
                                else {
                                    mapcoreLayer = this.layerService.getLayerForSaveMap(layer, this.isNewMap);
                                    this.mapLayers.push(mapcoreLayer);
                                    try {
                                        for (_c = tslib_1.__values(layer.layers.toArray()), _d = _c.next(); !_d.done; _d = _c.next()) {
                                            groupedLayer = _d.value;
                                            originalLayers.push(groupedLayer);
                                            groupedMapcoreLayer = this.layerService.getLayerForSaveMap(groupedLayer, this.isNewMap);
                                            this.mapLayers.push(groupedMapcoreLayer);
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        if (this.map.isSystem || this.isNewMap) {
                            this.map.id = null;
                            this.map.isSystem = false;
                            this.map.layers = null;
                        }
                        this.map.extentJSON = JSON.stringify(this.mapViewRef.extent.toJSON());
                        _e = this;
                        return [4 /*yield*/, this.mapApi.saveMap(this.map, this.mapLayers, environment.appId)];
                    case 1:
                        _e.map = _f.sent();
                        // save map returns layers unordered, change to saved order
                        this.map.layers = this.mapLayers
                            .filter(function (mapLayer) { return !mapLayer.isGroupParent; })
                            .map(function (mapLayer) {
                            var layerInOrder = _this.map.layers.find(function (layer) { return layer.name === mapLayer.name; });
                            return layerInOrder;
                        });
                        this.mapViewRef.mapcoreViewProps = this.map;
                        if (!this.createNewFolder) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userApi.createNewUserFolder(this.newFolder)];
                    case 2:
                        currentFolder = _f.sent();
                        if (currentFolder) {
                            this.map.parentFolderId = currentFolder.id;
                        }
                        _f.label = 3;
                    case 3:
                        if (!this.map.parentFolderId) {
                            this.map.parentFolderId = this.parentFolderId;
                        }
                        if (!this.map.parentFolderId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.mapApi.saveMapToUserFolder(this.map.id, this.map.parentFolderId)];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5:
                        if (!(this.map.layers && this.map.layers.length > 0)) return [3 /*break*/, 7];
                        layerIds = this.map.layers.map(function (l) { return l.id; });
                        return [4 /*yield*/, this.layerService.getLayersFromApi(layerIds)];
                    case 6:
                        layersFromApi_1 = _f.sent();
                        this.map.layers.forEach(function (layer, index) {
                            var layerRef = originalLayers[index];
                            if (layerRef && layer && layer.id) {
                                layerRef.mapcoreProps.id = layer.id;
                                layerRef.mapcoreProps.name = layer.name;
                                var savedLayer = layersFromApi_1.filter(function (l) { return l.id === layer.id; })[0];
                                layerRef.mapcoreProps.idFromSavedLayer = savedLayer.id;
                                layerRef.mapcoreProps.isSystem = savedLayer.isSystem;
                                layerRef.mapcoreProps.parentId = savedLayer.parentId;
                                layerRef.mapcoreProps.typeId = savedLayer.typeId;
                                // Only populated when adding layer to map; once map is saved this should be cleared since it wouldn't be populated if layer is already in map
                                layerRef.mapcoreProps.idFromSavedMap = null;
                            }
                        });
                        _f.label = 7;
                    case 7:
                        this.onsave.emit(this.map.id.toString());
                        this.isSaving = false;
                        this.closeWindow();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.registerEvent('onsave', _this.onsave);
        _this.getClosestAncestor('mc-window').then(function (window) {
            if (window) {
                _this.windowRef = window;
                _this.windowRef.addEventListener('openChange', function (open) {
                    if (open.detail) {
                        _this.windowOpened();
                    }
                });
            }
            else {
                _this.windowOpened();
            }
        });
        return _this;
    }
    SaveMapComponent.prototype.ngOnInit = function () { };
    SaveMapComponent.prototype.ngAfterViewInit = function () {
        this.isReady();
    };
    SaveMapComponent.prototype.windowOpened = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, e_4, _b, map, _c, data, userMap, userMapFolders, existingMapsFolderId, userMapFolders_1, userMapFolders_1_1, folder, _d, _e, map;
            var _this = this;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.isLoading = true;
                        this.createNewFolder = false;
                        this.newFolder = null;
                        this.isNewMap = true; //default to true
                        this.isSaving = false;
                        this.disableCreateMap = true;
                        this.parentFolderId = 0;
                        this.nonPublicLayers = [];
                        if (!!this.mapRef) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        map = _f.sent();
                        if (!map) return [3 /*break*/, 3];
                        return [4 /*yield*/, map.ready];
                    case 2:
                        _f.sent();
                        this.mapRef = map.map;
                        this.mapViewRef = map.mapView;
                        return [3 /*break*/, 4];
                    case 3:
                        this.readyProblem('Map View Reference not supplied and reference from parent element could not be retrieved.');
                        _f.label = 4;
                    case 4:
                        if (!(this.userId === null)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.authService.GetCurrentUser().subscribe(function (user) {
                                if (user) {
                                    _this.userId = user.id;
                                }
                            })];
                    case 5:
                        _f.sent();
                        _f.label = 6;
                    case 6:
                        this.map = this.mapViewRef.mapcoreViewProps;
                        if (!this.map) {
                            this.map = this.createNewMap();
                        }
                        if (this.isNewMap === null) {
                            this.isNewMap = this.map.isSystem;
                        }
                        _c = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, this.applicationId, 'maps')];
                    case 7:
                        _c.parentFolders = _f.sent();
                        this.parentFolders = this.parentFolders.sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()); });
                        this.parentFolders.unshift({ id: 0, name: 'No parent' });
                        if (!(this.map.id !== null)) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.mapService.getUserMap(this.userId, this.map.id, environment.appId)];
                    case 8:
                        data = _f.sent();
                        userMap = data && data.length && data[0].userMaps && data[0].userMaps.length ? data[0].userMaps[0].map : null;
                        this.isExistingMap = !!userMap;
                        if (!this.isExistingMap) return [3 /*break*/, 10];
                        //if this is an existing map, check if it the user owns it, if so prevent forcing 'create new map'
                        if (userMap && userMap.userMaps.filter(function (m) { return m.userId === _this.userId && m.accessLevel === 'OWNER'; }).length) {
                            this.disableCreateMap = false;
                            this.isNewMap = false;
                        }
                        return [4 /*yield*/, this.mapService.getUserMapsFolders(this.userId, environment.appId)];
                    case 9:
                        userMapFolders = (_f.sent())[0].folders;
                        existingMapsFolderId = -1;
                        try {
                            for (userMapFolders_1 = tslib_1.__values(userMapFolders), userMapFolders_1_1 = userMapFolders_1.next(); !userMapFolders_1_1.done; userMapFolders_1_1 = userMapFolders_1.next()) {
                                folder = userMapFolders_1_1.value;
                                try {
                                    for (_d = tslib_1.__values(folder.maps), _e = _d.next(); !_e.done; _e = _d.next()) {
                                        map = _e.value;
                                        if (map.id === this.map.id) {
                                            existingMapsFolderId = folder.id;
                                            break;
                                        }
                                    }
                                }
                                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                finally {
                                    try {
                                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                                    }
                                    finally { if (e_4) throw e_4.error; }
                                }
                                if (existingMapsFolderId !== -1) {
                                    break;
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (userMapFolders_1_1 && !userMapFolders_1_1.done && (_a = userMapFolders_1.return)) _a.call(userMapFolders_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        this.parentFolderId = existingMapsFolderId !== -1 ? existingMapsFolderId : 0;
                        _f.label = 10;
                    case 10:
                        this.cdr.detectChanges();
                        _f.label = 11;
                    case 11:
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SaveMapComponent.prototype.createNewMap = function () {
        return {
            applicationID: this.applicationId,
            description: '',
            id: null,
            isPublic: false,
            isSystem: false,
            name: '',
            sharedWith: [],
            userId: this.userId
        };
    };
    SaveMapComponent.prototype.isNewFolder = function (event) {
        this.createNewFolder = event;
        if (this.createNewFolder) {
            this.newFolder = {
                name: '',
                category: 'maps',
                parentUserFolderId: this.parentFolderId,
                userId: this.userId,
                applicationId: this.applicationId
            };
        }
        else {
            this.newFolder = null;
        }
    };
    SaveMapComponent.prototype.parentFolderSelected = function (value) {
        if (this.createNewFolder) {
            this.newFolder.parentUserFolderId = value;
        }
        else {
            this.parentFolderId = value;
        }
    };
    SaveMapComponent.prototype.closeWindow = function () {
        this.isNewMap = null;
        this.windowRef.close();
    };
    SaveMapComponent.prototype.hasNonPublicLayers = function (layers) {
        var _this = this;
        var e_5, _a;
        this.nonPublicLayers = [];
        if (!this.map.isPublic) {
            return false;
        }
        try {
            for (var layers_2 = tslib_1.__values(layers), layers_2_1 = layers_2.next(); !layers_2_1.done; layers_2_1 = layers_2.next()) {
                var layer = layers_2_1.value;
                if (layer.mapcoreProps.url) {
                    // Feature layers don't have permissions
                    continue;
                }
                if (layer.mapcoreProps.permissions
                    && !layer.mapcoreProps.permissions.some(function (p) { return _this.PUBLIC_LAYER_NAMES.has(p.name); })) {
                    this.nonPublicLayers.push(layer.mapcoreProps);
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (layers_2_1 && !layers_2_1.done && (_a = layers_2.return)) _a.call(layers_2);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return this.nonPublicLayers.length > 0;
    };
    SaveMapComponent.prototype.folderTrack = function (_index, item) {
        return item.id;
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], SaveMapComponent.prototype, "showPublic", void 0);
    return SaveMapComponent;
}(BaseComponent));
export { SaveMapComponent };
